import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-overview-item-v2',
    templateUrl: './overview-item-v2.component.html',
    styleUrls: ['./overview-item-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverviewItemV2Component implements OnInit {
  @Input() itemDetails;
  @Input() itemData;
  @Input() itemList;
  @Input() index;
  constructor(public translate: TranslateService) { }

  ngOnInit() {
    console.log("this.itemDetails",this.itemDetails)
    console.log("this.itemData",this.itemData)
  }
  isArray(obj : any ) {
    return Array.isArray(obj)
  }
  getOverviewColsClass(cols: number[]){
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass
  }
}
